//= =====================
// Report Actions
//= =====================
export const REQUEST_REPORTS 	  = 'REQUEST_REPORTS'
export const RECEIVE_REPORTS	  = 'RECEIVE_REPORTS'
export const REQUEST_REPORT 	  = 'REQUEST_REPORT'
export const RECEIVE_REPORT	 	  = 'RECEIVE_REPORT'
export const REQUEST_DELTA 	 	  = 'REQUEST_DELTA'
export const RECEIVE_DELTA	 	  = 'RECEIVE_DELTA'
//= =====================
// User Actions
//= =====================
export const REQUEST_USER		  = 'REQUEST_USER'
export const RECEIVE_USER		  = 'RECEIVE_USER'
export const REQUEST_USER_REPORTS = 'REQUEST_USER_REPORTS'
export const RECEIVE_USER_REPORTS = 'RECEIVE_USER_REPORTS'
//= =====================
// Comments Actions
//= =====================
export const REQUEST_COMMENTS 	  = 'REQUEST_COMMENTS'
export const RECEIVE_COMMENTS	  = 'RECEIVE_COMMENTS'
export const REFRESH_COMMENTS	  = 'REFRESH_COMMENTS'
export const ADD_COMMENT		  = 'ADD_COMMENT'
export const DELETE_COMMENT		  = 'DELETE_COMMENT'
//= =====================
// Replies Actions
//= =====================
export const REQUEST_REPLIES	  = 'REQUEST_REPLIES'
export const RECEIVE_REPLIES	  = 'RECEIVE_REPLIES'
export const REFRESH_REPLIES	  = 'REFRESH_REPLIES'
export const ADD_REPLY			  = 'ADD_REPLY'
export const DELETE_REPLY		  = 'DELETE_REPLY'
//= =====================
// Authentication Actions
//= =====================
export const AUTH_USER			  = 'AUTH_USER'
export const AUTH_ERROR			  = 'AUTH_ERROR'
export const UNAUTH_USER		  = 'UNAUTH_USER'
//= =====================
// API Actions
//= =====================
export const LIKE_REPORT		  = 'LIKE_REPORT'
export const SAVE_REPORT		  = 'SAVE_REPORT'
export const REQUEST_LIKES		  = 'REQUEST_LIKES'
export const RECEIVE_LIKES		  = 'RECEIVE_LIKES'
export const REQUEST_SAVES		  = 'REQUEST_SAVES'
export const RECEIVE_SAVES		  = 'RECEIVE_SAVES'

export const REQUEST_SEARCH		  = 'REQUEST_SEARCH'
export const RECEIVE_SEARCH		  = 'RECEIVE_SEARCH'
export const REFRESH_SEARCH		  = 'REFRESH_SEARCH'

export const CREATE_REPORT		  = 'CREATE_REPORT'
export const UPDATE_REPORT		  = 'UPDATE_REPORT'
export const ADD_QUILL			  = 'ADD_QUILL'

export const GET_USER			  = 'GET_USER'
export const GET_USER_REPORTS	  = 'GET_USER_REPORTS'

export const FOLLOW_USER		  = 'FOLLOW_USER'
export const UNFOLLOW_USER		  = 'UNFOLLOW_USER'
export const VIEW_FOLLOWERS		  = 'VIEW_FOLLOWERS'
export const VIEW_FOLLOWING		  = 'VIEW_FOLLOWING'


// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js